import React from 'react';
import { UserCardV1 } from '../../../../../../features/User/UserCard';
import { GetDate, GetTime } from '../../../../../../utils/Show';
import cn from '../../../../../../utils/cn';

function ServiceActivityTr({ item }) {
    const displayMembers = item.members?.map((i, index) => {
        if (index === item.members.length - 1) {
            // Last item, no comma needed
            return i?.fullName;
        }
        // Not the last item, add a comma
        return `${i?.fullName}, `;
    });

    return (
        <tr
            className={cn(`group`, {
                'placeholder-mode': item?.demo
            })}
        >
            <td>
                <span>{item?.id}</span>
            </td>
            <td>
                <span>
                    <UserCardV1
                        hide
                        title={item?.userInfo?.fullName}
                        subTitle={item?.userInfo?.primaryEmail}
                        className="[&>div>h1]:!text-sm [&>div>p]:!text-xs"
                    />
                </span>
            </td>
            <td>
                <span className="font-medium">
                    {item?.members?.length ? displayMembers : '---'}
                </span>
            </td>
            <td>
                <span>{item?.title}</span>
            </td>
            <td>
                <span>{item?.description}</span>
            </td>
            <td className="!text-center">
                <span>
                    {GetDate(item?.timeCreated)}
                    <br />
                    <small>{GetTime(item?.timeCreated)}</small>
                </span>
            </td>
        </tr>
    );
}

function ServiceActivityTableHeader() {
    return (
        <thead>
            <tr className="*:!cursor-default">
                <th scope="col" className="w-20">
                    <span>ID</span>
                </th>
                <th scope="col">
                    <span>Activity By</span>
                </th>
                <th scope="col">
                    <span>Members</span>
                </th>
                <th>
                    <span>Title</span>
                </th>
                <th>
                    <span>Description</span>
                </th>
                <th scope="col" className="!w-38 !text-center">
                    <span>Date Created</span>
                </th>
            </tr>
        </thead>
    );
}

function TableWeb({ data }) {
    return (
        <div className="service_activity_tab mb-52">
            <table className="bik-table pb-7" cellPadding={0} cellSpacing={0}>
                <ServiceActivityTableHeader />
                <tbody>
                    {data && data?.length === 0 ? (
                        <tr className="hover:!bg-inherit">
                            <td colSpan={6} className="!text-left">
                                No Activity Found!
                            </td>
                        </tr>
                    ) : (
                        data?.map((item) => <ServiceActivityTr key={item.id} item={item} />)
                    )}
                </tbody>
            </table>
        </div>
    );
}

export default TableWeb;
